/**
 * Created by manuel on 11/15/16.
 */
import { Injectable } from '@angular/core';

import { Account } from '../../model/account.class';

@Injectable()
export class AccountService {
  public current = new Account();
}
